<template>
  <div class="">
    <router-link
      :to="{
        name: 'industrial_admin_branches',
        query: { companyID: this.$route.query.companyID, groupId: data.id },
      }"
      style="text-decoration: none; color: rgb(75, 44, 114)"
      class="btn dealers_btn mr-2"
      :title="$t('text.clickButtons.sites')"
      v-if="data.numberOfBranches > 0"
    >
      {{ $t("text.clickButtons.sites") }} {{ data.numberOfBranches }}
    </router-link>

    <button
      style="
        text-decoration: none;
        color: rgb(75, 44, 114);
        width: auto;
        cursor: not-allowed;
      "
      class="btn dealers_btn mr-2"
      :title="$t('text.clickButtons.mapSitesToView')"
      v-else
    >
      {{ $t("text.clickButtons.sites") }} {{ data.numberOfBranches }}
    </button>

    <router-link
      :to="{
        name: 'industrial_admin_users',
        query: {
          groupId: data.id,
          companyID: this.$route.query.companyID,
        },
      }"
      style="text-decoration: none; color: rgb(75, 44, 114)"
      class="btn dealers_btn mr-2"
      :title="$t('text.clickButtons.users')"
      v-if="
        data.numberOfUsers > 0 &&
        (userInfo.roles.includes('ManageUsers') ||
          userInfo.roles.includes('SupportAdmin') ||
          userInfo.roles.includes('PartnerAdmin'))
      "
    >
      {{ $t("text.clickButtons.users") }} {{ data.numberOfUsers }}
    </router-link>

    <button
      style="
        text-decoration: none;
        color: rgb(75, 44, 114);
        width: auto;
        cursor: not-allowed;
      "
      class="btn dealers_btn mr-2"
      :title="$t('text.clickButtons.mapUsersToGroup')"
      v-else-if="
        data.numberOfUsers == 0 &&
        (userInfo.roles.includes('ManageUsers') ||
          userInfo.roles.includes('SupportAdmin') ||
          userInfo.roles.includes('PartnerAdmin'))
      "
    >
      {{ $t("text.clickButtons.users") }} {{ data.numberOfUsers }}
    </button>

    <button
      style="text-decoration: none; border: none; cursor: default"
      class="btn"
      v-else
    ></button>

    <button
      @click="mapToBranch(data.id)"
      style="text-decoration: none; color: rgb(75, 44, 114)"
      class="btn dealers_btn"
      :title="$t('text.clickButtons.mapToBranch')"
    >
      {{ $t("text.clickButtons.mapToSite") }}
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
    };
  },

  computed: {
    userInfo() {
      const user = localStorage.getItem("userDetails")
        ? JSON.parse(localStorage.getItem("userDetails"))
        : null;

      if (user) {
        if (!user.roles) {
          if (user.role) {
            user.roles = user.role.split(",");
            localStorage.setItem("userDetails", JSON.stringify(user));
          }
        }
      }
      return user;
    },
  },

  mounted() {},
  methods: {
    mapToBranch: function (id) {
      this.$eventHub.$emit("_mapGroupToBranch", id);
    },
  },
};
</script>
